import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { EventEmitter, Injectable, Output } from '@angular/core'
import { FormBuilder, FormControl } from '@angular/forms'
import { catchError, throwError } from 'rxjs'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Player } from '../../../core/models/player.model'
import { environment } from '../../../../environments/environment'
import { Metrics } from '../../../core/models/metrics.model' 
import { METRICS_ARRAY } from '../../atleti-metrics/services/atleti-metrics.service'

@Injectable({
  providedIn: 'root'
})
export class MetricsService {
  METRICS = METRICS_ARRAY
  
  constructor(private _snackBar: MatSnackBar, private fb:FormBuilder, private http: HttpClient) { }

  readonly baseURL = environment.DOMAIN_URL+'/api/seasonmetrics/'

  @Output() filtersSubmittedEvent = new EventEmitter<null>()

  FiltersSubmitted(){
    this.filtersSubmittedEvent.emit()
  }

  filters = this.fb.group({
    season: [''],
    match: [''],
    rival: [''],
    player: this.fb.control<string[] | null>(null),
    starter: [''],
    minutes: this.fb.control<number | null>(null),
    fromDate: this.fb.control<Date | null>(null),
    toDate: this.fb.control<Date | null>(null),
  })
  metricsForm = new FormControl('')
  metricsSelected: Metrics[] = []
  playersForm = new FormControl('')
  playersSelected: Player[] = []

  fetchFilteredMetrics(){
    this.filters.value.player = this.playersSelected.map(p => p._id)
    return this.http.post(this.baseURL+'filters',this.filters.value)
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }

  openSnackBar(message: string) {
    this._snackBar.open(message)
  }
}